import LogOut from './log-out';

export default LogOut;
